/**
 * @param {HTMLImageElement} image
 * @param {import("react-image-crop").PixelCrop} crop
 * @param {string} fileName
 * @returns {Promise<string>} object URL for cropped jpeg blob
 */
export function getCroppedImg(image, crop, fileName) {
  const canvas = document.createElement("canvas");
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width * scaleX;
  canvas.height = crop.height * scaleY;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width * scaleX,
    crop.height * scaleY
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        blob.name = fileName;
        resolve(window.URL.createObjectURL(blob));
      },
      "image/jpeg",
      1.0
    );
  });
}

/**
 * @param {string} dataUrlOrBlobUrl
 * @param {number} imageMaxWidth
 * @param {number} aspectRatio
 * @returns {Promise<string>} data URL (jpeg)
 */
export function resizeAndConvertImage(dataUrlOrBlobUrl, imageMaxWidth, aspectRatio) {
  const image = new Image();

  return new Promise((resolve, reject) => {
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      let width = image.naturalWidth;
      let height = image.naturalHeight;

      if (width > imageMaxWidth) {
        height = (height * imageMaxWidth) / width;
        width = imageMaxWidth;
      }

      const currentRatio = width / height;
      const expectedRatio = aspectRatio;

      if (Math.abs(currentRatio - expectedRatio) > 0.01) {
        if (currentRatio > expectedRatio) {
          width = height * expectedRatio;
        } else {
          height = width / expectedRatio;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(image, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(blob);
        },
        "image/jpeg",
        0.95
      );
    };
    image.onerror = () => reject(new Error("Image load failed"));
    image.src = dataUrlOrBlobUrl;
  });
}
